import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

const TOAST_LIFE_MS = 6000;

export const errorInterceptor: HttpInterceptorFn = (req, next) =>
{
    const keycloak = inject(Keycloak);
    const messages = inject(MessageService);

    return next(req).pipe(
        catchError((error: unknown) =>
        {
            if (error instanceof HttpErrorResponse && req.url.startsWith(environment.api.baseUrl))
            {
                if (error.status === 401)
                {
                    void keycloak.login({ redirectUri: window.location.href });
                }
                else if (error.status === 403)
                {
                    messages.add({ severity: 'warn', summary: 'Acesso negado', detail: 'Você não tem permissão para realizar esta ação.', life: TOAST_LIFE_MS });
                }
                else if (error.status === 0)
                {
                    messages.add({ severity: 'error', summary: 'Sem conexão', detail: 'Não foi possível se comunicar com o servidor.', life: TOAST_LIFE_MS });
                }
                else if (error.status >= 500)
                {
                    messages.add({ severity: 'error', summary: 'Erro no servidor', detail: 'Ocorreu um erro inesperado. Tente novamente em instantes.', life: TOAST_LIFE_MS });
                }
            }

            return throwError(() => error);
        })
    );
};
